import api from './api';

const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return {
      stats: response.data.stats,
      recentPets: response.data.recentPets || [],
    };
  },
};

export default dashboardService;
